import { handleEvent } from '../../helpers';

export default class {
  constructor(el) {
    this.el = el;
    this.selector = this.el.querySelector('.selector');
    this.dropdown = this.el.querySelector('.dropdown');
    this.active = false;
  }

  init() {
    this.handleEvents();
  }

  handleEvents() {

    this.clickListener = handleEvent('click', {
      el: this.selector,
      preventDefault: true,
      stopPropagation: true,
      callback: this.toggleDropdown.bind(this)
    });

  }

  toggleDropdown() {

    if(!this.active) {
      this.active = true;
      this.selector.classList.add('selected');
      this.dropdown.classList.add('shown');
    } else {
      this.active = false;
      this.selector.classList.remove('selected');
      this.dropdown.classList.remove('shown');
    }
  }

  destroy() {
    this.clickListener.destroy();
  }

}
